import { useRef } from "react";
import { WebAudioContext } from "@shared/context/WebAudio";

/**
 * Локальный провайдер общего AudioContext для плагинов комнаты
 * (синхронный плеер + метроном). Контекст создаётся один раз,
 * стартует в suspended-состоянии и разблокируется жестом пользователя
 * (клик по Play) через audioContext.resume() внутри startMusic.
 */
export const WebAudioProvider = ({ children }) => {
  const audioContextRef = useRef(null);

  if (audioContextRef.current === null && typeof window !== "undefined") {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (Ctx) {
      audioContextRef.current = new Ctx();
    }
  }

  return (
    <WebAudioContext.Provider value={audioContextRef.current}>
      {children}
    </WebAudioContext.Provider>
  );
};
